<div id="app-frame">
    <!-- <nz-spin class="global-spinner"
             [nzSpinning]="projectQuery.isLoading$ | async"
             nzSize="large">
        
    </nz-spin>  -->
    <router-outlet></router-outlet>
</div>